import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { httpReauest } from "../../utils/httpRequest";
import { toast } from "react-toastify";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "../../config";

const TableBuySell = ({ data, setData }) => {
  const { user, setUser } = useContext(AuthContext);

  return (
    <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
      <div className="flex items-center gap-2 justify-between mb-7">
        <h2 className="title mb-3">کاربر ها از هدیه سایت ({data?.length})</h2>
      </div>
      <table class="w-full text-sm text-left rtl:text-right text-blue-100 dark:text-blue-100">
        <thead class="text-xs text-white uppercase bg-orange-600 dark:text-white">
          <tr>
            <th scope="col" class="px-6 py-3">
              تلفن همراه
            </th>
            <th scope="col" class="px-6 py-3">
              تاریخ ثبت نام
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((req) => {
            return (
              <tr class="bg-orange-500 border-blue-40">
                <td class="px-6 py-4">{req?.phone}</td>
                <td class="px-6 py-4">
                  {req?.createdAt &&
                    new Intl.DateTimeFormat("fa-IR").format(
                      new Date(req?.createdAt),
                    )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableBuySell;
